import Vue from "vue";
// import "default-passive-events";
import moment from "moment";
import "../assets/css/style.scss";
import "../assets/css/iconfont/iconfont.css";
import "./element/index";
import "./axios";
import UploadProgress from "../components/upload-progress";


moment.defaultFormat = "YYYY-MM-DD HH:mm:ss"

// import "./mock";
Vue.prototype.bus = new Vue(); // global event bus
Vue.prototype.moment = moment;
Vue.prototype.rowDateFormatter = (row, column, cellValue) => {
  return moment(new Date(cellValue)).format();
}
Vue.use(UploadProgress);
